module.exports = __webpack_public_path__ + "img/check-circle.46e43e3f.svg";